// extracted by mini-css-extract-plugin
export default {"button":"hbXlzVkXOd3hzysK5tqm","icon":"OaLVUT0zLtcW9LnN982B"};